import { LoadingSpinner } from '@simplywallst/ui-core';
import { StyledGrid } from './styled';

export const LoadingState = () => (
  <StyledGrid
    placeContent="center"
    data-cy-id="loading-portfolio-performance-timeseries"
  >
    <LoadingSpinner light />
  </StyledGrid>
);
